/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Simple_Door_Guided_P2Inputs */

const en_simple_door_guided_p2 = /** @type {(inputs: Simple_Door_Guided_P2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Polish before launch — ${i?.price}`)
};

const id_simple_door_guided_p2 = /** @type {(inputs: Simple_Door_Guided_P2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rapikan sebelum terbit — ${i?.price}`)
};

/**
* | output |
* | --- |
* | "Polish before launch — {price}" |
*
* @param {Simple_Door_Guided_P2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_guided_p2 = /** @type {((inputs: Simple_Door_Guided_P2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Guided_P2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_guided_p2(inputs)
	return en_simple_door_guided_p2(inputs)
});